import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../graphql/GraphQlProvider';
import {WcvDocument} from '../../graphql/documents.datatypes';
import {gqlDocument} from './getDocument.api';

export interface CreateDocumentInput {
    data: {
        __typename: undefined,
        completed_documents: undefined,
        overdueGroupMembers: undefined,
        id: undefined,
        parent_document_id?: number
        user_id: number
        type: number
        type_id: number
        title: string
        description: string
        url: string
        available_for_download: boolean
        has_completion_date: boolean
        completion_date?: string
        verified: boolean
        tour_role: number
    }
}

interface CreateDocumentData {
    createDocument: WcvDocument
}

export const CREATE_DOCUMET_MUTATION = gql`
    mutation createDocument($data: CreateDocumentInput!) {
        createDocument(data: $data) {
            ${gqlDocument}
        }
    }
`;

export const createDocument = () => useMutation<CreateDocumentData, CreateDocumentInput>(
    CREATE_DOCUMET_MUTATION,
    {
        update: updateCacheByType('Document'),
    }
);

export default createDocument;